import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { formatDistance } from 'date-fns';
import { ButtonComponent } from '../components/button/button.component';
import { DialogCloseButtonComponent } from '../dialog-close-button/dialog-close-button.component';

@Component({
  selector: 'sqep-inactivity',
  imports: [
    MatDialogModule,
    MatIconModule,
    DialogCloseButtonComponent,
    ButtonComponent,
  ],
  templateUrl: './inactivity.component.html',
  styleUrl: './inactivity.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InactivityComponent {
  public data = inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<InactivityComponent>);
  protected readonly inactiveTime = signal<number>(this.data.inactiveTime);

  updateData(inactiveTime: number) {
    this.inactiveTime.set(inactiveTime);
  }

  protected readonly inactivity = computed(() => {
    return `There has been no activity for a while, you will be automatically logged out in ${this.formatInactivityTime(this.inactiveTime())}`;
  });

  logout() {
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(false);
  }

  private formatInactivityTime(inactiveTime: number): string {
    const duration = (time: number) =>
      formatDistance(0, time * 1000, { includeSeconds: false });
    return duration(inactiveTime);
  }
}
